import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function MyDocuments() {
  const { user, loading } = useAuth();
  const [docs, setDocs] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get("/documents");
        setDocs(data || []);
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, [user]);

  const download = async (doc) => {
    const { data } = await api.get(`/documents/${doc.id}/stamped.pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${doc.title || "document"}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <div>
        <Nav />
        <div className="px-4 py-20 text-center label-tag">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div>
        <Nav />
        <div className="max-w-md mx-auto px-4 py-12">
          <Link to="/cardholder/login?next=/documents" className="label-tag underline">
            Log in to see your documents
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Nav />
      <div className="max-w-md mx-auto px-4 py-8">
        <div className="flex items-end justify-between gap-3">
          <div>
            <div className="label-tag text-neutral-500">Document seal</div>
            <h1 className="font-display font-black text-3xl mt-1">My documents</h1>
          </div>
          <Link to="/documents/new" className="label-tag px-3 py-2 bg-black text-white brutal-btn">
            Upload
          </Link>
        </div>
        {error && <p className="mt-3 label-tag text-red-600">{error}</p>}
        <ul className="mt-6 space-y-3">
          {docs.map((doc) => (
            <li key={doc.id} className="border-2 border-black bg-white p-4">
              <div className="font-display font-bold">{doc.title}</div>
              <div className="text-sm mt-1">
                {doc.holder_first_name} {doc.holder_surname}
              </div>
              <div className="label-tag text-xs mt-1">{doc.asset_code}</div>
              <button
                type="button"
                onClick={() => download(doc)}
                className="mt-3 label-tag underline"
              >
                Download stamped PDF
              </button>
            </li>
          ))}
          {docs.length === 0 && !error && (
            <li className="text-sm text-neutral-600">No documents yet.</li>
          )}
        </ul>
      </div>
    </div>
  );
}
